export enum StrategyTypes  {
    MINDBODY = "MINDBODY",
    BOOKER = "BOOKER",
    MANUAL = "MANUAL",
    BOULEVARD = "BOULEVARD",
    SQUARE = "SQUARE",
}
